// extracted by mini-css-extract-plugin
export default {"custom-radio-group":"CustomRadioGroup_custom-radio-group__efLJ6"};